import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {
  addWarehouse,
  deleteDock,
  getWarehouse,
  getWarehouseAdmins,
  setInvitedAdmin,
  setWarehouse,
  updateWarehouse
} from "../../store/actions/warehouse";
import Modal from "react-modal";
import AddUser from "../../components/popups/AddUser";
import validator from "validator";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import {setUserAdded} from "../../store/actions/user";
import moment from "moment";
import classnames from "classnames";
import {setErrors} from "../../store/actions/error";

Modal.setAppElement('#root');

const format = 'hh:mm A';

class WarehouseDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: this.props.match.params.hasOwnProperty('id'),
      modalIsOpen: false,
      name: {
        value: '',
        isValid: false
      },
      admins: [],
      from: {
        value: null,
        isValid: false
      },
      to: {
        value: null,
        isValid: false,
        touched: false
      },
      openedOvernight: false,
      invitedAdmins: [],
      docks: [{id: null, name: ''}],
      formValid: false,
      previousAdmins: []
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
  }

  componentDidMount() {
    this.props.getWarehouseAdmins();

    if (this.state.editing) {
      this.props.getWarehouse(this.props.match.params.id, this.props.history);
    }
  }

  componentWillReceiveProps(nextProps) {
    const admins = [...nextProps.admins];
    admins.forEach(admin => admin.checked = false);
    if (this.state.editing) {
      if (nextProps.warehouse.warehouse_managers) {
        let whAdmins = [];
        whAdmins = nextProps.warehouse.warehouse_managers.map(admin => ({
          ...admin.company_admin,
          managerId: admin.manager_id
        }));
        let from = nextProps.warehouse.open_date;
        let to = nextProps.warehouse.close_date;

        if (from && to) {
          from = moment().hours(from.substr(0, 2)).minutes(from.substr(from.indexOf(':') + 1, 2));
          to = moment().hours(to.substr(0, 2)).minutes(to.substr(to.indexOf(':') + 1, 2));
        }

        admins.forEach(admin => {
          whAdmins.forEach(whadmin => {
            if (admin.id === whadmin.id) {
              admin.checked = true;
              admin.managerId = whadmin.managerId;
            }
          });
        });
        this.setState({
          name: {
            isValid: true,
            value: nextProps.warehouse.name
          },
          from: {
            ...this.state.from,
            isValid: true,
            value: from
          },
          to: {
            ...this.state.to,
            isValid: true,
            value: to
          },
          openedOvernight: nextProps.warehouse.opened_overnight,
          docks: nextProps.warehouse.warehouse_docks
        });
      }
    }

    this.setState({
      admins,
      previousAdmins: JSON.parse(JSON.stringify(admins))
    }, this.validateForm);
  }

  componentWillUnmount() {
    if (this.state.editing) {
      this.props.setWarehouse({});
    }

    this.props.setErrors(null);
  }

  handleUserInput(ev) {
    const {errors} = this.props;
    const fieldName = ev.target.name;
    const value = ev.target.value;

    if (errors && errors[fieldName]) {
      this.props.setErrors({
        ...this.props.errors,
        [fieldName]: null
      });
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        value
      }
    }, () => this.validateField(fieldName, value));
  }

  onSelectAdmin(isNew, selector) {
    const admins = [...this.state.admins];
    const invitedAdmins = [...this.state.invitedAdmins];

    if (!isNew) {
      admins.forEach(admin => {
        if (admin.id === selector) {
          admin.checked = !admin.checked;
        }
      });
    } else {
      invitedAdmins.forEach(admin => {
        if (admin.email === selector) {
          admin.checked = !admin.checked;
        }
      });
    }

    this.setState({
      admins,
      invitedAdmins
    }, this.validateForm);
  }

  validateField(fieldName, value) {
    let isValid = this.state[fieldName].isValid;
    let errorMessage = this.state[fieldName].errorMessage;

    switch (fieldName) {
      case 'name':
        isValid = !validator.isEmpty(value);
        errorMessage = 'Name is required';
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    const {name, admins, to, from, docks, invitedAdmins} = this.state;
    this.setState({
      formValid: name.isValid && (admins.some(admin => admin.checked) || invitedAdmins.some(admin => admin.checked)) &&
          to.isValid && from.isValid && docks.every(dock => dock.name.trim().length > 0)
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  getAdminDisplayName(firstName, lastName) {
    return `${firstName} ${lastName}`;
  }

  openModal() {
    this.setState({
      modalIsOpen: true
    });
  }

  closeModal(admin = false) {
    const invitedAdmins = [...this.state.invitedAdmins];
    if (admin.hasOwnProperty('email')) {
      invitedAdmins.push({
        ...admin,
        checked: true
      });
    }

    this.setState({
      modalIsOpen: false,
      invitedAdmins
    });
    this.props.setUserAdded(false);
    this.props.setInvitedAdmin(null);
  }

  onTimeChange(value, field) {
    let isValid = this.state[field].isValid;
    let touched = false;

    if (field === 'from') {
      isValid = !!value;
    } else {
      const {from} = this.state;
      const fromMoment = moment().set({
        hours: from.value.format(format).substr(0, 2),
        minutes: from.value.format(format).substr(from.value.format(format).indexOf(':') + 1, 2)
      });
      isValid = moment(value).isAfter(fromMoment);
      touched = true;
    }

    this.setState({
      [field]: {
        ...this.state[field],
        value,
        isValid,
        touched
      }
    }, this.validateForm);
  }

  addDockDoor() {
    const docks = [...this.state.docks];
    docks.push({id: null, name: ''});
    this.setState({docks});
  }

  deleteDockDoor(index, id) {
    if (id) {
      this.props.deleteDock(id);
    }

    const docks = [...this.state.docks];
    docks.splice(index, 1);
    this.setState({docks})
  }

  onDocksChange(ev, index) {
    const docks = [...this.state.docks];

    docks[index].name = ev.target.value;
    this.setState({docks}, this.validateForm);
  }

  onSubmit(ev) {
    ev.preventDefault();

    if (this.state.formValid) {
      const {docks, admins, from, to, openedOvernight, name, invitedAdmins, previousAdmins} = this.state;
      const checkedAdmins = admins.filter(admin => admin.checked);

      if (!this.state.editing) {
        const requestBody = {
          docks: docks.map(dock => dock.name),
          warehouse_admins: checkedAdmins.map(admin => admin.id),
          opened_overnight: openedOvernight,
          name: name.value,
          invited_warehouse_admins: invitedAdmins
        };

        if (!openedOvernight) {
          requestBody.open_date = moment(from.value, format).format('HH:mm');
          requestBody.close_date = moment(to.value, format).format('HH:mm');
        }

        this.props.addWarehouse(requestBody, this.props.history);
      } else {
        const adminsToAdd = [];
        const adminsToDelete = [];

        admins.forEach(admin => {
          previousAdmins.forEach(prevAdmin => {
            if (admin.id === prevAdmin.id) {
              if (admin.checked !== prevAdmin.checked) {
                if (admin.checked) {
                  adminsToAdd.push(admin)
                } else {
                  adminsToDelete.push(admin);
                }
              }
            }
          });
        });
        invitedAdmins.forEach(admin => {
          if (admin.checked) {
            adminsToAdd.push(admin);
          }
        });

        const requestBody = {
          warehouse_id: this.props.match.params.id,
          opened_overnight: openedOvernight,
          name: name.value,
          added_managers: adminsToAdd.map(admin => admin.id),
          removed_managers: adminsToDelete.map(admin => admin.managerId)
        };

        if (!openedOvernight) {
          requestBody.open_date = moment(from.value, format).format('HH:mm');
          requestBody.close_date = moment(to.value, format).format('HH:mm');
        }

        this.props.updateWarehouse(requestBody, this.props.history);
      }
    }
  }

  toggleOpenedOvernight(e) {
    const checked = e.target.checked;
    const {to, from} = this.state;

    to.isValid = checked;
    from.isValid = checked;

    this.setState({
      openedOvernight: !this.state.openedOvernight,
      to,
      from
    }, this.validateForm);
  }

  render() {
    const {name, to} = this.state;
    const {errors} = this.props;
    const admins = this.state.admins.map(admin => (
        <li key={admin.id}>
          <div className="custom-control custom-checkbox">
            <input type="checkbox" className="custom-control-input" id={admin.id} checked={admin.checked}
                   onChange={() => this.onSelectAdmin(false, admin.id)}/>
            <label className="custom-control-label"
                   htmlFor={admin.id}>{this.getAdminDisplayName(admin.user.first_name, admin.user.last_name)}</label>
          </div>
        </li>
    ));
    const invitedAdmins = this.state.invitedAdmins.map((admin, index) => (
        <li key={index}>
          <div className="custom-control custom-checkbox">
            <input type="checkbox" className="custom-control-input" id={index} checked={admin.checked}
                   onChange={() => this.onSelectAdmin(true, admin.email)}/>
            <label className="custom-control-label"
                   htmlFor={index}>{this.getAdminDisplayName(admin.first_name, admin.last_name)}</label>
          </div>
        </li>
    ));
    const docks = (
        <ul>
          <li>
            {this.state.docks ? this.state.docks.map((dock, index) => (
                <div className="form-group" key={index}>
                  <label>Name / Number of the Dock Door {index + 1}</label>
                  <div className="field">
                    <input type="text" className="form-control" placeholder="Name / Number of the Dock Door"
                           value={this.state.docks[index].name} onChange={ev => this.onDocksChange(ev, index)}/>
                    <button type="button" className="btn delete-field"
                            onClick={() => this.deleteDockDoor(index, dock.id)}><i
                        className="icon-delete"/></button>
                  </div>
                </div>
            )) : null}
          </li>
        </ul>
    );

    return (
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <form className="card" onSubmit={this.onSubmit.bind(this)}>
                  <div className="card-header">
                    <h2>{this.state.editing ? 'Edit' : 'Add'} warehouse</h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div
                            className={classnames('form-group pb-md-2', {'invalid': errors && errors.name})}>
                          <label htmlFor="warehouse-name">Warehouse name *</label>
                          <input type="text" id="warehouse-name" className="form-control" placeholder="Warehouse name *"
                                 defaultValue={name.value} onChange={this.handleUserInput} name="name"
                                 onBlur={this.handleInputBlur}/>
                          {errors && errors.hasOwnProperty('name') && (<p className="error-msg">{errors.name}</p>)}
                        </div>
                        <div className="form-group">
                          <label htmlFor="warehouse-admin">Warehouse admin *</label>
                          <ul className="pb-md-3" id="warehouse-admin">
                            {admins}
                            {invitedAdmins}
                          </ul>
                          <input type="button" className="btn btn-link" value="Add new admin" onClick={this.openModal}/>
                        </div>
                        <div className="working-hours pb-md-3">
                          <label htmlFor="working-hours">Working hours *</label>
                          <div className="row">
                            <div className="col">
                              <div className="form-group">
                                <label htmlFor="name">From</label>
                                <TimePicker
                                    showSecond={false}
                                    className="form-control"
                                    format={format}
                                    use12Hours
                                    value={this.state.from.value}
                                    inputReadOnly
                                    onChange={value => this.onTimeChange(value, 'from')}
                                    disabled={this.state.openedOvernight}
                                />
                              </div>
                            </div>
                            <div className="col">
                              <div className={classnames('form-group', {'invalid': !to.isValid && to.touched})}>
                                <label htmlFor="name">To</label>
                                <TimePicker
                                    showSecond={false}
                                    className="form-control"
                                    format={format}
                                    use12Hours
                                    inputReadOnly
                                    value={this.state.to.value}
                                    onChange={value => this.onTimeChange(value, 'to')}
                                    disabled={!this.state.from.value || this.state.openedOvernight}
                                />
                                {!to.isValid && to.touched && (<p className="error-msg">Please select valid time.</p>)}
                              </div>
                            </div>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id="opened-overnight"
                                   defaultValue={this.state.openedOvernight}
                                   checked={this.state.openedOvernight}
                                   onChange={this.toggleOpenedOvernight.bind(this)}/>
                            <label className="custom-control-label" htmlFor="opened-overnight">Opened overnight</label>
                          </div>
                        </div>
                        <div className="dock-doors">
                          {docks}
                          <input type="button" className="btn btn-lg btn-primary" defaultValue="Add dock doors"
                                 onClick={this.addDockDoor.bind(this)}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer text-right">
                    <Link to='/warehouses' type="button" className="btn btn-lg btn-secondary mr-3">Cancel</Link>
                    <input type="submit" className="btn btn-lg btn-primary" value="Add"
                           disabled={!this.state.formValid}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal}>
            <AddUser closeModal={this.closeModal} addingWarehouse={true}/>
          </Modal>
        </main>
    );
  }
}

WarehouseDetails.propTypes = {
  admins: PropTypes.array.isRequired,
  getWarehouseAdmins: PropTypes.func.isRequired,
  setUserAdded: PropTypes.func.isRequired,
  addWarehouse: PropTypes.func.isRequired,
  getWarehouse: PropTypes.func,
  warehouse: PropTypes.object,
  setInvitedAdmin: PropTypes.func,
  deleteDock: PropTypes.func,
  updateWarehouse: PropTypes.func.isRequired,
  setWarehouse: PropTypes.func.isRequired,
  errors: PropTypes.any,
  setErrors: PropTypes.func.isRequired
};

WarehouseDetails.defaultProps = {
  warehouse: {
    warehouse_managers: [],
    open_date: '',
    close_date: ''
  }
};

const mapStateToProps = state => ({
  admins: state.warehouse.admins,
  warehouse: state.warehouse.warehouse,
  errors: state.error.errors
});

const mapDispatchToProps = dispatch => ({
  getWarehouseAdmins: () => dispatch(getWarehouseAdmins()),
  setUserAdded: payload => dispatch(setUserAdded(payload)),
  addWarehouse: (data, history) => dispatch(addWarehouse(data, history)),
  getWarehouse: (id, history) => dispatch(getWarehouse(id, history)),
  setInvitedAdmin: admin => dispatch(setInvitedAdmin(admin)),
  deleteDock: id => dispatch(deleteDock(id)),
  updateWarehouse: (body, history) => dispatch(updateWarehouse(body, history)),
  setWarehouse: () => dispatch(setWarehouse()),
  setErrors: errors => dispatch(setErrors(errors))
});

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseDetails);



// WEBPACK FOOTER //
// ./src/containers/WarehouseDetails/WarehouseDetails.jsx